import { useState } from "hono/jsx";
import { z } from "@hono/zod-openapi";

export interface UseValidatedInputProps {
  // deno-lint-ignore no-explicit-any
  schema: z.ZodTypeAny;
  initialValue?: string;
  name?: string;
}

export const useValidatedInput = (
  { schema, initialValue = "", name }: UseValidatedInputProps,
) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState(
    !schema.safeParse(initialValue).success ? false : true,
  );

  const validate = (val: string, force = false): boolean => {
    const result = schema.safeParse(val);
    const valid = result.success;
    setIsValid(valid);

    if (!valid) {
      if (force || error) {
        // deno-lint-ignore no-explicit-any
        const err = result.error as any;
        const issues = err.errors || err.issues || [];
        const msg = issues[0]?.message || "Invalid input";
        setError(msg);
      }
      return false;
    }

    setError("");
    return true;
  };

  const onInput = (e: Event) => {
    const val = (e.target as HTMLInputElement).value;
    setValue(val);
    validate(val, false);
  };

  return {
    value,
    setValue,
    error,
    setError,
    isValid,
    validate: (force = false) => validate(value, force),
    bind: {
      value,
      onInput,
      schema,
      error,
      name,
    },
  };
};
